import { PendingContent, Spinner, Status } from 'plume-ui';
import React, { FunctionComponent } from 'react';

import { alarmCategoryColors } from '../../utils/AlarmUtils';
import useCriteriaNames from '../Monitor/hooks/useCriteriaNames';

export const AlarmLegend: FunctionComponent = () => {
  const { loading, getCriteriaName } = useCriteriaNames();

  return (
    <div className="HealthSummary__AlarmLegend__Container">
      <PendingContent loading={loading} loader={Spinner}>
        <div className="HealthSummary__AlarmLegend">
          {alarmCategoryColors.map(({ id, fill }) => {
            return (
              <span key={id} className="HealthSummary__LegendCell">
                <Status
                  color={fill}
                  label={getCriteriaName(id)}
                  variant="legend"
                />
              </span>
            );
          })}
        </div>
      </PendingContent>
    </div>
  );
};
